// extracted by mini-css-extract-plugin
export default {"Message":"message-text_Message__FtGnW"};